import { isArray } from 'class-validator';

import { isObject } from '../assertFunctions';
import { jsonObjectClone } from '../jsonClone/jsonClone';

/** Transform arbitrarily nested objects that resolve to primitives into
 * a flattened structure.
 *
 * Arrays will not be traversed and will be cloned and assigned to the
 * current property directly.
 * Better generic type inference might be implemented later.*/
export const flatten = <T>(obj: Record<string, unknown>): Record<string, T> => {
  const keyVals = new Map<string, T>();
  const joinKeys = (key: string, prefix?: string) =>
    prefix ? [prefix, key].join('.') : key;
  const extractFromEntries = (
    obj: Record<string, unknown>,
    prefix?: string,
  ) => {
    const entries = Object.entries(obj);
    for (const [key, value] of entries) {
      if (isArray(value)) {
        keyVals.set(joinKeys(key, prefix), jsonObjectClone(value) as T);
        continue;
      }
      if (!isObject(value)) {
        keyVals.set(joinKeys(key, prefix), value as T);
        continue;
      }
      extractFromEntries(value, joinKeys(key, prefix));
    }
  };
  extractFromEntries(obj);
  return Object.fromEntries(keyVals.entries());
};
